import { SORT_ORDER } from 'common/constants';
import { iconClassNames } from 'common/constants/TaxonomyConstants';

const { ASCENDING, DESCENDING } = SORT_ORDER;

/**
 * @method to map the icon based on objectType recieved
 * @returns iconClassNames
 */
export const getMappingIcon = (objectType: string) => {
	const iconClassName = iconClassNames[objectType];
	return iconClassName || null;
};

/**
 * @method to generate Annotation Data
 * @returns object
 */
export const generateAnnotationData = (
	labelClass: string,
	iconClass: string,
	iconLabelClass: string,
	iconLabelTestid: string,
	iconLabel: string,
) => ({
	labelClass,
	iconClass,
	iconLabelClass,
	iconLabelTestid,
	iconLabel,
});

/**
 * @method to sort based on order
 */
export const sortFields = (
	sortOrder: string,
	setSortOrder: (value: React.SetStateAction<string>) => void,
) => {
	if (sortOrder === ASCENDING) {
		setSortOrder(DESCENDING);
	} else if (sortOrder === DESCENDING) {
		setSortOrder(ASCENDING);
	}
};
